var Industry = "Отрасль";
var Aerospace = "Авиационно-космическая отрасль";
var Agriculture = "Сельское хозяйство";
var Automotive = "Автотранспорт";
var Education = "Образование";
var Gaming = "Игры";
var Government = "Government";
var Healthcare = "Здравоохранение";
var Hospitality = "Гостиничный бизнес";
var Manufacturing = "Производство";
var Mining = "Горнодобывающая промышленность";
var Other = "Другое";
var Retail = "Розничная торговля";
var Telecommunications = "Телекоммуникации";
var Travel = "Туристические услуги";
var industry = {
	Industry: Industry,
	Aerospace: Aerospace,
	Agriculture: Agriculture,
	Automotive: Automotive,
	"Computers & electronics": "Компьютеры и электроника",
	"Consumer goods": "Товары повседневного спроса",
	Education: Education,
	"Financial services": "Финансовые услуги",
	Gaming: Gaming,
	Government: Government,
	Healthcare: Healthcare,
	Hospitality: Hospitality,
	"Life sciences": "Медико‑биологические разработки",
	Manufacturing: Manufacturing,
	"Marketing & advertising": "Маркетинг и реклама",
	"Media & entertainment": "Мультимедиа и индустрия развлечений",
	Mining: Mining,
	"Non-profit organization": "Некоммерческая организация",
	"Oil & gas": "Нефть и газ",
	Other: Other,
	"Power & utilities": "Коммунальные службы и электроснабжение",
	"Professional services": "Профессиональные услуги",
	"Real estate & construction": "Недвижимость и строительство",
	Retail: Retail,
	"Software & internet": "Software & Internet",
	Telecommunications: Telecommunications,
	"Transportation & logistics": "Транспорт и логистика",
	Travel: Travel,
	"Wholesale & distribution": "Оптовая торговля и дистрибуция"
};

export { Aerospace, Agriculture, Automotive, Education, Gaming, Government, Healthcare, Hospitality, Industry, Manufacturing, Mining, Other, Retail, Telecommunications, Travel, industry as default };
